<template>
  <div class="reviewing">
    <div class="next">
      <button v-if="!isReadyToMoveToNextRound" @click="markAsReadyToMoveToNextRound" class="button">Next round →</button>
      <button v-if="isReadyToMoveToNextRound" @click="markAsReadyToMoveToNextRound" class="button">Waiting for others... ({{playersNotReadyToMoveToNextRound}})</button>
    </div>
    <div class="cards">
      <div
        v-for="player in players"
        :class="'card ' + (turn === player.name ? 'is-selected' : '')"
        :key="player.name"
      >
        <div class="card_front">
          <h1>
            <span>{{player.name}}'s card</span>
          </h1>
          <img :src="`/cards/${gameState.variant}/${player.selectedCard}.jpg`">
          <div class="voters">
            <div
              v-for="voter in players.filter(p => p.votedCard === player.selectedCard)"
              :key="voter.name"
            >
              <span>{{voter.name}}</span>
            </div>
          </div>
        </div>
        <div class="card_back"></div>
      </div>
      <div class="clearfix"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "GameReviewing",
  computed: {
    ...mapState(["gameState"]),
    ...mapGetters(["players", "playersNotReadyToMoveToNextRound", "players", "turn", "isReadyToMoveToNextRound"])
  },
  methods: {
    ...mapActions(["markAsReadyToMoveToNextRound"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.reviewing {
  height: 100%;
  background: #6D3896;
  overflow: scroll;
}

.next {
  padding: 20px;
  text-align: right;
}
.next .button {
  background: rgba(255, 255, 255, 0.1);
}

.cards {
  padding: 10px 10px;
  /* overflow-y: scroll; */
}

.card {
  float: left;
  width: 50%;
  padding: 10px 10px 20px 10px;
  position: relative;
  box-sizing: border-box;
  perspective: 1000px;
}
.card h1 {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  height: 40px;
  margin: -22px 0 0 0;
  padding: 0 10px;
  display: none;
}
.card.is-selected h1 {
  display: block;
}
.card h1 span {
  display: inline-block;
  background: #25172f;
  color: white;
  border-radius: 20px;
  height: 32px;
  line-height: 32px;
  padding: 0 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card img {
  width: 100%;
  border-radius: 10px;
  border: none;
  background: transparent;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}
.card.is-selected img {
  box-shadow: 0 0 0 7px #25172f, 0 5px 15px rgba(0, 0, 0, 0.4);
}
.card_front,
.card_back {
  backface-visibility: hidden;
  animation-duration: 1s;
  /* animation-iteration-count: 1; */
  animation-fill-mode: both;
}
.card_front {
  position: relative;
  animation-name: reveal;
}
.card_back {
  background: #25172f;
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 22px;
  animation: reveal 0.8s 1;
  border-radius: 10px;
  animation-name: hide;
  transform: rotateY(180deg);
}
/* .card:nth-child(1) .card_front, .card:nth-child(1) .card_back {
  animation-delay: 1s;
}
.card:nth-child(2) .card_front, .card:nth-child(2) .card_back {
  animation-delay: 2s;
}
.card:nth-child(3) .card_front, .card:nth-child(3) .card_back {
  animation-delay: 3s;
}
.card:nth-child(4) .card_front, .card:nth-child(4) .card_back {
  animation-delay: 4s;
}
.card:nth-child(5) .card_front, .card:nth-child(5) .card_back {
  animation-delay: 5s;
}
.card:nth-child(6) .card_front, .card:nth-child(6) .card_back {
  animation-delay: 6s;
}
.card:nth-child(7) .card_front, .card:nth-child(7) .card_back {
  animation-delay: 7s;
}
.card:nth-child(8) .card_front, .card:nth-child(8) .card_back {
  animation-delay: 8s;
}
.card:nth-child(9) .card_front, .card:nth-child(9) .card_back {
  animation-delay: 9s;
}
.card:nth-child(10) .card_front, .card:nth-child(10) .card_back {
  animation-delay: 10s;
} */

.voters {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10px;
}
.voters div {
  width: 100%;
  text-align: center;
}
.voters span {
  display: inline-block;
  background: white;
  color: black;
  border-radius: 20px;
  height: 32px;
  line-height: 32px;
  padding: 0 20px;
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clearfix {
  clear: both;
}

@keyframes reveal {
  0%   { transform: rotateY(-180deg); }
  100% { transform: rotateY(0deg); }
}
@keyframes hide {
  0%   { transform: rotateY(0deg); }
  100% { transform: rotateY(180deg); }
}
</style>
